import { ProductListItem } from './ProductListItem';

export class SavedQuotationData {
  constructor(storeId, id, total, clientId, products) {
    this.id = id;
    this.total = total;
    this.clientId = clientId;
    this.products = [];
    products.forEach((x) => {
      const element = x.product;
      const inventoryStore = element.inventoryProduct.find((y) => y.storeId === storeId);
      const item = new ProductListItem(element.id, element.name, element.barcode,
        element.baseCost, element.images, element.discountSpecials, element.comboSpecials,
        element.model, element.brand, element.keys, inventoryStore);
      this.products.push(item);
    });
  }
}
